import axios from 'axios';
import store from '../store';
const APIUrl = 'https://shielded-sea-13781.herokuapp.com';

const axiosBase = axios.create({
  baseURL: APIUrl,
  headers: { "content-type": 'application/json' }
})
const getAPI = axios.create({
  baseURL: APIUrl
})
getAPI.interceptors.response.use(undefined, function (err) {
  // if error response status is 401, it means the request was invalid due to expired access token
  if (err.config && err.response && err.response.status === 401 || err.config && err.response && err.response.status === 403) {
    store.dispatch('refreshToken') // attempt to obtain new access token by running 'refreshToken' action
      .then(access => {
        localStorage.setItem(access)
      })
      .catch(err => {
        store.dispatch('logoutUser');
        return Promise.reject(err)
      })
  }
})

export { axiosBase, getAPI }
